import styled from "styled-components";
// export const DASH_BOARD_STYLE_MAPPINGS = {
//     TILE_1: "#1E88E5", // Employee count (Bright blue for clear focus)
//     TILE_2: "#00BFAE", // Submitted count (Vibrant teal for immediate action)
//     TILE_3: "#FF6F61", // Pending count (Bright orange indicating pending tasks)
//     TILE_4: "#FF9800", // Total hours (Strong red for urgent attention)
//     TILE_5: "#34A853", // Approved Hours (Fresh green for positive completion)
//     TILE_6: "#8E24AA", // Holiday/Vacation (Bright purple for a sense of relaxation)
//     DEFAULT: "#FEFEFE" // Default color (Neutral background)
// }
export const DASH_BOARD_STYLE_MAPPINGS = {
    TILE_1: "#001b66", // Employee count (Bright blue for clear focus)
    TILE_2: "#158c7f", // Submitted count (Vibrant teal for immediate action)
    TILE_3: "#d71019", // Pending count (Bright orange indicating pending tasks)
    TILE_4: "#fda901", // Total hours (Strong red for urgent attention)
    TILE_5: "#31af36", // Approved Hours (Fresh green for positive completion)
    TILE_6: "#e42232", // Holiday/Vacation (Bright purple for a sense of relaxation)
    DEFAULT: "#FEFEFE" // Default color (Neutral background)
}
export const DASHBOARD_EVENT_MAPPINGS = {
    "APPROVED": {
        backColor: "#00FF00",
        borderColor: "#00FF00",
        fontColor: "#004d00"
    },
    "REJECTED": {
        backColor: "#FF0000",
        borderColor: "#FF0000",
        fontColor: "#FFFFFF",
    },
    "SUBMITTED": {
        backColor: "#FFFF2E", 
        borderColor: "#FFFF2E",
        fontColor: "#333333",
    },
    "DRAFT": {
        backColor: "#C5C5C5",
        borderColor: "#C5C5C5",
        fontColor: "#333333",
    }
}
export const StyledDashBoardContainer = styled.section`
display:flex;
flex-wrap:wrap;
flex-direction;column;
padding: 0rem;
.tma_dashboard_row {
    display:flex;
    width:100%;
    gap:2rem;
    justify-content: space-around;
    flex-wrap: wrap;
    @media (max-width: 640px) {
        gap: 1rem;
    }
    .tma_dashboard_item {
    height: 200px;
    width: 200px;
    max-width: 33%;
    border: 1px solid transparent;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

.tma_dashboard_item header.tma_db_tile_title {
    text-align: center;
    margin-top: 1rem;
}

.tma_dashboard_item p.tma_db_tile_text {
    width: 100%;
    height: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:18px;
    font-weight:bold;
}
.tma_dashboard_item:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4); /* Darker shadow on hover */
}

.tma_dashboard_item:hover::before {
    background: rgba(255, 255, 255, 0.6); /* Increase glossiness on hover */
}
}
.tma_dashboard_header
{
    width:100%;
    display:flex;
    padding:0rem;
    align-items: center;
    @media (max-width: 640px) {
        flex-wrap: wrap;
        gap: 1rem;
    }
    h1{
        font-size:24px;
    }
    .week-picker-display{
        box-shadow: none;
        border: 1px solid #ddd;
        border-radius: 0;
        padding: 0;
        scale: none;
        height: 41px;
        div.selected-week-display {
            margin: 0;
            .arrow-container {
                width: 40px;
                height: 40px;
                border-radius: 0;
                background: var(--primary-text);
                svg {fill: #fff; stroke: #fff; width: 16px; height: 16px;}
            }
        }
            div.selected-week-indicator{gap: 0;}
    }
}
     .tma_dashboard_actions
    {
        margin-left:auto;
        display:flex;
        align-items:center;
        gap:0.5rem;
        @media (max-width: 640px) {
            margin-left:0;
            flex-wrap: wrap;
        }
            button {height: 40px;}
    }
&.tma_emp_dashboard_container{
.tma_dashboard_header{
    padding:0;
    .tma_dashboard_actions
    {
        margin-left:auto;
        display:flex;
        align-items:center;
        gap:0.5rem;
        .month-picker-options{
            left:-140px;
        }
        button.tma_popup_btn:disabled {
            background-color: var(--input-disabled-color);
            color: grey;
            cursor: not-allowed;
      }
    }
}
    
.tma_employee_dashboard_content
{
    width:100%;
    overflow: auto;
    @media (max-width: 767px) {
        height: 50vh;
    }
    .month_default_main {
        @media (max-width: 767px) {
            min-width: 767px;
        }
    
    }
}
section.tma_employee_dashboard_summary
{
    display:flex;
    gap:1rem;
    flex-direction:column;
    width: 100%;
    border: 1px solid #ddd;
    margin: 1rem auto;
    padding: 1rem;
    flex-wrap: wrap;
    .tma-text_summary{
        width:60%;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .tma-text_summary,.tma_progress_summary
    {
        display:flex;
        gap:1rem;
        white-space:nowrap;
        width:100%;
        flex-wrap: wrap;
    }
    .tma_col
    {
        display:flex;
        flex-direction:column;
        gap:0.75rem;
        @media (max-width: 767px) {
            width: 48%;
        }
    }
}
}
`
export const StyledTiles = styled.div`
    width: 100%;
    padding: 2rem 0;
    gap: 2rem;
    display: flex;
    flex-direction: column;
    @media (max-width: 640px) {
        padding: 1rem 0;
        gap: 1rem;
    }
`
export const StyledDashboardCard = styled.div`
    width: 30.5%;
    padding: 1rem;
    height: auto;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    .hours {
        width: 90px;
        height: 90px;
        border-radius: 100%;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        background: radial-gradient(circle, ${props => props.backgroundcolor} -100%, #ffffff 65%);
        .tma_db_tile_text {
            font-weight: 600;
            font-size: 32px;
            color: ${props => props.textcolor};
            sub {
                font-size: 14px;
                position: absolute;
            }
        }
            .tma_db_icon {
                display: flex;
                svg {
                    width: 35px;
                    height: 35px;
                    fill: ${props => props.textcolor};
                }
            }
    }
    .content {
        .tma_db_tile_title {
            font-size: 14px;
            font-weight: 500;
            padding-left: 10px;
            color: #555;
        }
        .tma_db_tile_text {
            font-size: 21px;
            font-weight: 700;
            padding-left: 10px;
            color: #333;
        }
    }
    @media (max-width: 890px) {
        width: 47%;
    }
    @media (max-width: 640px) {
        width: 98%;
    }
`

export const StyledReportModal = styled.div`
position:fixed;
top:0;
left:0;
width:100vw;
height:100vh;
display:flex;
align-items:center;
justify-content:center;
background-color:rgba(0,0,0,0.35);
z-index:9999;
.report-modal-content{
     width:70%;
    background-color:#fff;
    position:relative;
    padding:1.5rem;
    @media (max-width:478px){
        width: 90%;
        height: 80%;
    }
    p.total-records-indicator{
        margin-top:1rem;
    }
    header.modal-header{
        margin-bottom:1rem;
        @media (max-width:478px){
            font-size:12px;
        }
        .secondary-row{
            display:flex;
            justify-content:space-between;
            @media (max-width:478px){
                align-items: anchor-center;
                gap: 1.75rem;
            }
            .download-action{
                cursor:pointer;
                svg{
                    fill:var(--primary-text);
                }
            }
        }
        p.subtitle{
            color:var(--label-text);
            font-size:13px;
            margin-top:0.45rem;
            .report-week-label{
                margin-left:0.25rem;
            }
        }
    }
}
.tma_report_table{
   
    max-height:500px;
    @media (max-width:478px){
        max-height:300px;
    }
}
.holiday-cell .month_default_cell_inner {
    background: var(--holiday-bg) !important;
    color: Orange !important;
    font-weight: bold;
}
`